/* eslint-disable no-shadow */
import actions from "./actions"
import mutations from "./mutations"

const state = () => ({
  segments: [],
  smsTemplates: [],
  emailTemplates: [],
  announcements: [],
})

const getters = {
  getSegments: store => store.segments,
  getSmsTemplates: store => store.smsTemplates,
  getEmailTemplates: store => store.emailTemplates,
  getAnnouncements: store => store.announcements,
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

export default module
